/**
 * Tech Repository Hook
 *
 * Provides access to the tech repository from the context.
 */

import { useRepositoryContext } from '../repositories';
import type { ITechRepository } from '../repositories/interfaces/ITechRepository';

/**
 * Hook to access the tech repository
 * Must be used within a RepositoryProvider
 */
export function useTechRepository(): ITechRepository {
  const { techs } = useRepositoryContext();
  return techs;
}
